import { createSelector } from 'reselect';
import { getFormValues, isInvalid } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { initialState } from './reducer';
import { FORM_NAME } from './constants';

export const selectCargoPickupModalDomain = state => state.cargoPickupModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsReqInfoLoadingSelector = () =>
	createSelector(
		selectCargoPickupModalDomain,
		({ isReqInfoLoading, isFormSending }) => isReqInfoLoading || isFormSending,
	);

export const getReqInfoSelector = () =>
	createSelector(selectCargoPickupModalDomain, ({ reqInfo }) => {
		return reqInfo;
	});

export const getFormInitialValuesSelector = () =>
	createSelector(selectCargoPickupModalDomain, getFormValues(FORM_NAME), ({ reqInfo }, formValues) => {
		return { ...reqInfo, ...formValues };
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'cargo_pickup');
	});

export const getActiveReqIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'cargo_pickup' ? query?.id : null;
	});

export const getFormValuesSelector = () => createSelector(getFormValues(FORM_NAME), formValues => formValues);

export const getFormIsInvalidSelector = () => createSelector(isInvalid(FORM_NAME), isInvalid => isInvalid);
